import _ from 'underscore';
import { createSelector } from 'reselect';
import entitiesSelector from './entities_selector';

const add = createSelector(
  (layers, activeMeetings) => layers,
  (layers, scheduledMeetings) => scheduledMeetings,
  (layers, scheduledMeetings) => {
    if(layers.length === 0) { return scheduledMeetings; }

    return scheduledMeetings.map(scheduledMeeting => {
      layers.forEach(layer => {
        let isMatch = _.every(Object.keys(layer.conditions), property => {
          let isScheduledMeeting = property === 'scheduledMeeting';
          return _.isMatch(
            isScheduledMeeting ? scheduledMeeting : scheduledMeeting[property], 
            layer.conditions[property]
          );
        });

        if(isMatch) {
          scheduledMeeting.classNames.push(layer.selectedClass);
        }
      });
      return scheduledMeeting;
    });
  }
);

const meetingLayersSelector = entitiesSelector(state => state.meetingLayers);

meetingLayersSelector.add = add;

export default meetingLayersSelector;




/** WEBPACK FOOTER **
 ** ./src/js/selectors/meeting_layers_selector.js
 **/